import { Badge } from "design-system/atoms/Badge"
import { UserCircle } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useWorkflowBuilder } from "../../hooks/useWorkflowBuilder"

type SendInternalEmailNodeProps = {
  nodeIndex: number
}

export const SendInternalEmailNode = ({ nodeIndex }: SendInternalEmailNodeProps) => {
  const { t } = useTranslation()
  const { form } = useWorkflowBuilder()
  const recipients = form.watch(`nodes.${nodeIndex}.config.email.recipients`)

  return (
    <div className="text-sm flex flex-col gap-1 mt-1">
      <span className="font-medium truncate">
        {form.watch(`nodes.${nodeIndex}.config.email.subject`)}
      </span>
      <div>
        <Badge variant="secondary">
          <UserCircle className="size-4" />
          <span>
            {t("campaigns.action.availableActions.SendInternalEmail.config.totalRecipients", {
              count: recipients && "length" in recipients ? recipients.length : 0,
            })}
          </span>
        </Badge>
      </div>
    </div>
  )
}
